import { createContext, useContext, useState } from 'react';

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settingsPairs, setSettingsPairs] = useState({
        w55_manual_override: {
            override: false,
            setpoint_value: 0   
        },
        w95_manual_override: {
            override: false,
            setpoint_value: 0
        },
        bo1_manual_override: {
            override: false,
            setpoint_value: 0
        },
        w7_manual_override: {
            override: false,
            setpoint_value: 0
        }
    });

    return (
        <SettingsContext.Provider value={{ settingsPairs, setSettingsPairs }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};